interface EnvironmentService {
  baseUrlAuth: string;
  baseUrlCore: string;
  wwwUrl: string;
  appUrl: string;
  rootDomain: string;
  recaptchaKey: string;
  intercomAppId: string;
}

const environmentService: EnvironmentService = {
  baseUrlAuth:
    (import.meta.env.VITE_BASE_URL_AUTH as string) ||
    (import.meta.env.VITE_BASE_URL as string),
  baseUrlCore:
    (import.meta.env.VITE_BASE_URL_CORE as string) ||
    (import.meta.env.VITE_BASE_URL as string),
  wwwUrl: import.meta.env.VITE_WWW_URL as string,
  appUrl: import.meta.env.VITE_APP_URL as string,
  rootDomain: import.meta.env.VITE_ROOT_DOMAIN as string,
  recaptchaKey: import.meta.env.VITE_RECAPTCHA_KEY as string,
  intercomAppId: import.meta.env.VITE_INTERCOM_APP_ID as string
};

export default environmentService;
